import React, { useState, useEffect } from "react";
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, Link } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import SignupPage from './pages/SignupPage';
import LoginPage from './pages/LoginPage';
import ProductPage from './pages/ProductPage';
import ProductImageUploadPage from "./pages/ProductImageUploadPage";
import AccountPage from "./pages/AccountPage"
import AddProductPage from "./pages/AddProductPage"
import CartPage from "./pages/CartPage"
import CheckoutSuccessfulPage from "./pages/CheckoutSuccessfulPage"
import CheckoutFailedPage from "./pages/CheckoutFailedPage"
import { FaShoppingCart } from 'react-icons/fa';
import { IconBold } from "@tabler/icons-react";


function horizontalSpacer(width) {
  return <div style={{ display: "inline-block", width: width }}></div>;
}

function verticalSpacer(height) {
  return <div style={{ height: height }}></div>;
}

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

function App() {
  const [shrink, setShrink] = useState(false);
  const [userData, setUserData] = useState(null);
  const [navItems, setNavItems] = useState([
    { name: "Home", path: "/" },
    // { name: "Products", path: "/products" },
    { name: "Contact", path: "/contact" }
  ]);
  const [itemsInUserCart, setItemsInUserCart] = useState(0)
  const [mounted, setMounted] = useState(false);
  
  
  // useEffect(() => {
  //     // Update localStorage when the state changes
  //   const userDataFromStorage = localStorage.getItem('userData');
  //   if (userDataFromStorage) {
  //     setUserData(JSON.parse(userDataFromStorage));
  //   }
  //   console.log("User Data from localStorage:", userDataFromStorage);
  // }, []);


  // Handle scroll to shrink navbar
  useEffect(() => {
    const handleScroll = () => {
      setShrink(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  useEffect(() => {
    setMounted(true);
  }, [])


//     useEffect(() => {
//   const checkStorage = () => {
//     const userDataFromStorage = localStorage.getItem("userData");
//     if (!userDataFromStorage) return;

//     const parsedData = JSON.parse(userDataFromStorage);

//     const userCartFromStorage = localStorage.getItem("userCart");
//     let totalIncart = 0
//     if(userCartFromStorage){
//       const parsedCartData = JSON.parse(userCartFromStorage);
//       for (let i = 0; i < parsedCartData.length; i++){
//         totalIncart += parsedCartData[i].count
//       }
//     }
//     setItemsInUserCart(totalIncart)

//     // Use a functional update to get the most FRESH state
//     setUserData(prevUser => {
//       // Only update if we don't have user data yet
//       if (prevUser === null) {
//         return parsedData;
//       }
//       return prevUser;
//     });

//     // if (parsedData?.admin) {
//     //   setNavItems(prevItems => {
//     //     // Prevent duplicate nav items
//     //     const exists = prevItems.find(item => item.path === "/ProductImageUpload");
//     //     if (!exists) {
//     //       return [...prevItems, { name: "Product Image Upload", path: "/ProductImageUpload" }];
//     //     }
//     //     return prevItems;
//     //   });
//     // }
//   };

//   checkStorage();
//   const interval = setInterval(checkStorage, 3000);
//   return () => clearInterval(interval);
// }, []);


useEffect(() => {
  const checkStorage = () => {
    // Handle cart FIRST
    const userCartFromStorage = localStorage.getItem("userCart");

    let totalIncart = 0;

    if (userCartFromStorage) {
      const parsedCartData = JSON.parse(userCartFromStorage);
      totalIncart = parsedCartData.reduce(
        (acc, item) => acc + item.count,
        0
      );
    }

    setItemsInUserCart(totalIncart);

    // Handle userData separately
    const userDataFromStorage = localStorage.getItem("userData");

    if (userDataFromStorage) {
      const parsedData = JSON.parse(userDataFromStorage);

      setUserData(prevUser => {
        if (prevUser === null) {
          return parsedData;
        }
        return prevUser;
      });
    }
  };

  checkStorage();
  const interval = setInterval(checkStorage, 3000);

  return () => clearInterval(interval);
}, []);


  


  const navItem2 = [
    { name: "Login", path: "/login" },
  ];

  const navItem3 = [
    { name: "Signup", path: "/signup" },
  ];

  return (
    <BrowserRouter>
      <div className='appNav' style={{ fontFamily: "sans-serif", margin: 0, padding: 0, alignItems: "center",  }}>
        {/* Navbar */}
        <div
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: shrink ? "8px 24px" : "16px 10px",
            background: "#89807c", //"rgba(139, 132, 132, 0.9)",
            backdropFilter: shrink ? "blur(10px)" : "none",
            boxShadow: shrink
              ? "0 4px 12px rgba(0,0,0,0.2)"
              : "0 0 0 rgba(0,0,0,0)",
            transition: "all 0.3s ease",
            borderRadius: "0 0 30px 30px",
            // borderBottom: shrink ? "1px solid #eaeaea" : "none",
          }}
        >
          {/* Logo */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ fontWeight: useWindowSize().width > 558 ? 600 : 550, fontSize: useWindowSize().width > 558 ? 18 : 12 }}>Carmel House Supply</span>
          </div>

          {/* Desktop nav items */}
          <div style={{ display: "flex", alignItems: "center" }}>
            {navItems.map((item, idx) => (
              <React.Fragment key={idx}>
                <Link
                  to={item.path}
                  style={{
                    padding: "8px 12px",
                    borderRadius: 8,
                    textDecoration: "none",
                    color: "#333",
                    fontWeight: 500,
                    transition: "background 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#f0f0f0";
                  }}
                  onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
                >
                  {item.name}
                </Link>
                {idx < navItems.length - 1 && horizontalSpacer(8)}
              </React.Fragment>
            ))}

            {/* Buttons */}
            {horizontalSpacer(16)}
            <Link
              to={userData ? "/AccountPage" : "/login"}
              style={{ textDecoration: "none" }}
            >
            <button
              style={{
                padding: "8px 16px",
                borderRadius: 6,
                border: "1px solid #333",
                background: "transparent",
                cursor: "pointer",
                marginRight: 8,
                color: "#000000ff",
                fontWeight: "bolder"
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#f0f0f0")
              }
              onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
              // onClick={() => (window.location.href = '/login')}
              
            >
              {userData ? `${userData.firstName}` : "Login"}
            </button>
            </Link>



            {horizontalSpacer(16)}
            <Link
              to={"/CartPage"}
              style={{ textDecoration: "none" }}
            >
              <div className="cartButtonContainer">
              <button
                style={{
                  borderRadius: 6,
                  border: "1px solid #333",
                  background: "transparent",
                  cursor: "pointer",
                  marginRight: 8,
                  color: "#000000ff",
                  fontSize: "19px",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#f0f0f0")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
              >
                <FaShoppingCart />
              </button>
              {mounted && itemsInUserCart > 0 && (
                <div className='cartButtonContainerNumber'>
                  {itemsInUserCart}
                </div>
              )}
            </div>
            </Link>
            {/* <button
              style={{
                padding: "8px 16px",
                borderRadius: 6,
                border: "none",
                background: "#2563EB",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              Book a call
            </button> */}
          </div>
        </div>

        {/* Page content */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/product" element={<ProductPage />} />
          <Route path="/ProductImageUpload" element={<ProductImageUploadPage />} />
          <Route path="/AccountPage" element={<AccountPage />} />
          <Route path="/AddProductPage" element={<AddProductPage />} />
          <Route path="/CartPage" element={<CartPage />} />
          <Route path="/CheckoutSuccessfulPage" element={<CheckoutSuccessfulPage />} />
          <Route path="/CheckoutFailedPage" element={<CheckoutFailedPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;